import React from 'react';
import { useOtp } from '../lib/otp.js';

export { useOtp };

/** Inline "recovery email + code" block (register, settings). */
export function OtpEmailField({ otp, email, onEmail, placeholder = 'you@personal-mail.com', note }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
      <div style={{ display: 'flex', gap: 8 }}>
        <input className="km-input sm" type="email" placeholder={placeholder} value={email} disabled={otp.verified} onChange={(e) => { onEmail(e.target.value); if (otp.sent) otp.reset(e.target.value); }} />
        <button type="button" className="km-btn" disabled={otp.sendDisabled} onClick={() => otp.send(email)} style={{ padding: '0 14px', fontSize: 13 }}>{otp.sendLabel}</button>
      </div>
      {otp.awaiting && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <input className="km-input sm mono" style={{ width: 130, background: 'var(--km-bg)' }} placeholder="000 000" maxLength={7} value={otp.code} onChange={(e) => otp.setCode(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), otp.verify())} />
          <button type="button" className="km-btn-outline" onClick={() => otp.verify()}>Verify</button>
          <OtpMessage otp={otp} />
        </div>
      )}
      {note && <span className="km-faint" style={{ fontSize: 12 }}>{note}</span>}
    </div>
  );
}

/** Big code entry (forgot / find flows). */
export function OtpCodeCard({ otp, onVerify }) {
  return (
    <div className="km-card" style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <label className="km-field">6-digit code
        <input className="km-input mono" style={{ background: 'var(--km-bg)', fontSize: 20, letterSpacing: '.25em' }} placeholder="000 000" maxLength={7} autoFocus value={otp.code} onChange={(e) => otp.setCode(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && onVerify()} />
      </label>
      <OtpMessage otp={otp} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" className="km-btn" style={{ flex: 1, padding: 11 }} onClick={onVerify}>Verify code</button>
        <button type="button" className="km-btn-outline" disabled={otp.sendDisabled} onClick={() => otp.send()} style={otp.sendDisabled ? { color: 'var(--km-muted)' } : undefined}>{otp.sendLabel}</button>
      </div>
    </div>
  );
}

export function OtpMessage({ otp }) {
  const color = { ok: 'var(--km-ok)', bad: 'var(--km-bad)', muted: 'var(--km-muted)' }[otp.tone];
  return <span style={{ flex: 1, minWidth: 0, fontSize: 12.5, lineHeight: 1.4, color }}>{otp.msg}</span>;
}
